import { notInstalledURL } from '../constants';

// viewer.htmlが含まれるディレクトリ(末尾の"/"を含まない)を返す
export function getBasePath(): string {
  const path = window.location.pathname;
  const index = path.lastIndexOf('/');
  return path.substr(0, index);
}

export function isIE11(): boolean {
  return navigator.userAgent.indexOf('Trident/7') > -1;
}

export function getNotInstalledURLFullPath(): string {
  return `${location.origin}${getBasePath()}/${notInstalledURL}`;
}
